import { defineStore } from 'pinia';
import { SecureStorage } from '@/utils/storage';

const CACHE_KEY = 'app_sector';

export const useSectorStore = defineStore('sector', {
  state: () => ({
    currentSectorId: null,
    currentSectorName: null,
    structuresBySector: {},
    currentPageBySector: {},
    lastFetchedLangBySector: {},
    _cacheLoaded: false,
  }),

  actions: {
    _ensureCacheLoaded() {
      if (this._cacheLoaded) return;
      this._cacheLoaded = true;
      const cached = SecureStorage.getItem(CACHE_KEY);
      if (cached) {
        this.currentSectorId = cached.currentSectorId || null;
        this.currentSectorName = cached.currentSectorName || null;
        this.structuresBySector = cached.structuresBySector || {};
        this.currentPageBySector = cached.currentPageBySector || {};
        this.lastFetchedLangBySector = cached.lastFetchedLangBySector || {};
      }
    },

    _saveToCache() {
      SecureStorage.setItem(CACHE_KEY, {
        currentSectorId: this.currentSectorId,
        currentSectorName: this.currentSectorName,
        structuresBySector: this.structuresBySector,
        currentPageBySector: this.currentPageBySector,
        lastFetchedLangBySector: this.lastFetchedLangBySector,
      }, SecureStorage.TTL.SECTOR);
    },

    setCurrentSector(sector) {
      this._ensureCacheLoaded();
      this.currentSectorId = sector.id;
      this.currentSectorName = sector.name;
      this._saveToCache();
    },

    setStructuresForSector({ sectorId, structures, lang }) {
      this._ensureCacheLoaded();
      this.structuresBySector[sectorId] = structures;
      this.lastFetchedLangBySector[sectorId] = lang;
      this._saveToCache();
    },

    setCurrentPageForSector({ sectorId, page }) {
      if (sectorId) {
        this.currentPageBySector[sectorId] = page;
        this._saveToCache();
      }
    },

    clearCurrentSector() {
      this.currentSectorId = null;
      this.currentSectorName = null;
    },
  },
});
